import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StoreInfoContext = createContext({ info: null, reload: () => {} });

export const StoreInfoProvider = ({ children }) => {
  const [info, setInfo] = useState(null);
  const reload = () => api.get("/store-info").then(({ data }) => setInfo(data)).catch(() => {});
  useEffect(() => { reload(); }, []);
  return <StoreInfoContext.Provider value={{ info, reload }}>{children}</StoreInfoContext.Provider>;
};

export const useStoreInfo = () => useContext(StoreInfoContext);

export const INFO_PAGES = [
  { slug: "about", path: "/chi-siamo", label: "Chi siamo" },
  { slug: "contact", path: "/contatti", label: "Contatti" },
  { slug: "careers", path: "/lavora-con-noi", label: "Lavora con noi" },
  { slug: "privacy", path: "/privacy-policy", label: "Privacy Policy" },
  { slug: "terms", path: "/condizioni-di-vendita", label: "Condizioni di vendita" },
  { slug: "returns", path: "/resi-e-rimborsi", label: "Resi e rimborsi" },
  { slug: "shipping", path: "/spedizione-e-consegna", label: "Spedizione e Consegna" },
];
